import togglePanel from '../helpers/toggle-panel';
import popoutMenu from '../features/popout-menu';

const toolbar = (element: string): void => {
    const elm: HTMLDivElement | null = document.querySelector(element);

    if (!elm) {
        return;
    }

    togglePanel(elm);
    initToolbarSubmenu(elm);
};

const initToolbarSubmenu = (elm: HTMLDivElement): void => {
    const morePanel: HTMLDivElement | null = elm.querySelector('.js-panel__more');
    const morePanelContainer: HTMLDivElement | null = elm.querySelector('.js-panel__more-container');

    if (morePanel && morePanelContainer) {
        popoutMenu(morePanel, morePanelContainer, 'click');
    }
};

export default toolbar;
